<template>

  <b-navbar
    toggleable="md"
    type="dark"
    variant="primary"
  >

    <b-navbar-brand>
      <router-link
        :to="{name: 'admin-panel'}"
        title="AEqua Roma - Torna al Pannello di Controllo"
      >
        <span class="navbar-brand">
          <img
            src="../assets/images/logo.png"
            alt="AEqua Roma"
            style="height:2rem;"
          >
        </span>
      </router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-collapse
      is-nav
      id="nav_collapse"
    >

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-nav-form>
          <router-link
            :to="{name: 'admin-panel'}"
            class="text-white no-underline"
          >
            <button
              class="btn btn-primary"
              title="Torna al pannello di controllo"
            >
              <font-awesome-icon
                icon="th"
                size="lg"
              />
            </button>
          </router-link>

          <router-link
            :to="{name:'aiuto'}"
            class="text-white no-underline"
          >
            <button
              class="btn btn-primary"
              title="Aiuto"
            >
              <font-awesome-icon
                icon="question-circle"
                size="lg"
              />
            </button>
          </router-link>

          <b-dropdown
            v-if="$store.getters.isAuthenticated"
            variant="primary"
            class="m-md-2"
          >
            <template slot="button-content">
              <font-awesome-icon
                icon="user-circle"
                size="lg"
                class="mr-2"
              /> {{ $store.state.auth.user.nome }} {{ $store.state.auth.user.cognome }}
            </template>
            <!-- <b-dropdown-item
              v-if="$store.state.auth.user.logonMode === 'local'"
              @click="modificaPassword"
            >
              <font-awesome-icon
                icon="key"
                size="lg"
                class="text-success mr-2"
              />Modifica password
            </b-dropdown-item> -->
            <!-- b-dropdown-item
              v-if="$store.state.auth.user.logonMode === 'local'"
              @click="modificaMobile"
            >
              <font-awesome-icon
                icon="mobile-alt"
                size="lg"
                class="text-success mr-2"
              />Modifica numero mobile
            </!-->
            <b-dropdown-divider />
            <b-dropdown-item @click="logout">
              <font-awesome-icon
                icon="sign-out-alt"
                size="lg"
                class="text-danger mr-2"
              />Esci
            </b-dropdown-item>
          </b-dropdown>
        </b-nav-form>

      </b-navbar-nav>

    </b-collapse>
  </b-navbar>

  <!--
  <nav class="navbar fixed-top navbar-expand navbar-dark bg-primary">
    <router-link
      :to="{name: 'home'}"
      title="AEqua Roma - Torna alla pagina principale"
    >
      <span class="navbar-brand">
        <img
          src="../assets/images/logo.png"
          alt="AEqua Roma"
          style="height:2rem;"
        >
      </span>
    </router-link>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="hidden-xs-down">
      <ul class="navbar-nav mr-auto" />
      <form class="form-inline">
        <router-link :to="{name: 'home'}" class="text-white no-underline">
          <button class="btn btn-primary" title="Torna alla pagina principale">
            <font-awesome-icon icon="home" size="lg" />
          </button>
        </router-link>

        <router-link
          :to="{name:'aiuto'}"
          class="text-white no-underline"
        >
          <button class="btn btn-primary" title="Aiuto">
            <font-awesome-icon icon="question-circle" size="lg"/>
          </button>
        </router-link>

        <b-dropdown
          v-if="$store.getters.isAuthenticated"
          variant="primary"
          class="m-md-2"
        >
          <template slot="button-content">
            <font-awesome-icon icon="user-circle" size="lg" class="mr-2"
            /> {{ $store.state.auth.user.nome }} {{ $store.state.auth.user.cognome }}
          </template>
          <b-dropdown-item @click="modificaPassword">
            <font-awesome-icon icon="key" size="lg" class="text-success mr-2"/>Modifica password
          </b-dropdown-item>
          <b-dropdown-item @click="modificaMobile">
            <font-awesome-icon icon="mobile-alt" size="lg" class="text-success mr-2"/>Modifica numero mobile
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout">
            <font-awesome-icon icon="sign-out-alt" size="lg" class="text-danger mr-2"/>Esci
          </b-dropdown-item>
        </b-dropdown>
      </form>
    </div>
  </nav>
 -->
</template>

<script>
export default {
  name: 'AdminNavbar',
  methods: {
    modificaPassword () {
      // try {
      //  await this.$store.dispatch('logout')
      // } catch (err) {}

      this.$router.push({ name: 'changePassword' })
    },
    modificaMobile () {
      this.$router.push({ name: 'cambiaMobileUtente' })
    },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (err) { }
      this.$router.push({ name: 'loginAdmin' })
    }
  }
}
</script>
